module.exports = __webpack_public_path__ + "img/taiz1.2da9fa6e.png";